module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAgBAMAAACIv8e9AAAAHlBMVEVHcEz////////////////////////////////////JATChAAAACXRSTlMAkrbbMSNx2k6022zYAAAAQUlEQVQoz2NgwAIaBVGABAMD60w0EMDAgi7kwMAgbowCChmGFEhSQgFqDNj8iM3bmBqHEsCMNCx+xJIAsCQTTAAAXqtJlf1is3YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/assets/hamburger.png
// module id = 143
// module chunks = 15